import React from "react";

interface ProviderSummaryCardProps {
  summary: string;
}

/**
 * Displays the provider summary in a highlighted red/pink card.
 */
const ProviderSummaryCard: React.FC<ProviderSummaryCardProps> = ({
  summary,
}) => (
  <div className="flex flex-col gap-2 rounded-[10px] bg-[#FAE6E6] p-4">
    <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#BB0202]">
      Provider Summary
    </p>
    <p className="text-sm leading-[22px] text-[#3D3D3D]">{summary}</p>
  </div>
);

export default ProviderSummaryCard;
